var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 717 768"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M648.884 182.025c10.486 9.931 11.054 26.606 1.264 37.246L286.554 614.563c-4.806 5.228-11.497 8.249-18.538 8.372s-13.832-2.663-18.812-7.716L67.407 430.748c-10.142-10.291-10.142-26.977 0-37.268s26.586-10.292 36.728 0l162.789 165.184L612.178 183.31c9.784-10.639 26.219-11.215 36.705-1.284z"
  })));
};
export default SvgTick;